import docsPlugin from "@adsk/acc-reference-picker/es/plugins/docs";
import sheetsPlugin from "@adsk/acc-reference-picker/es/plugins/sheets";
import { useMemo } from "react";

export const useDropdownPlugins = () => {
  return useMemo(
    () => ({
      docsPlugin,
      sheetsPlugin,
    }),
    []
  );
};
